import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Refund = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20">
        <div className="container mx-auto max-w-7xl px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Refund & Return Policy</h1>
        </div>
      </section>

      {/* Refund Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <div className="prose max-w-none">
              <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-8">
                <p className="text-lg text-slate-700 leading-relaxed mb-0">
                  <strong>Important Notice:</strong> This Refund & Return Policy applies to all products and services offered on <strong>learnersedge.in</strong> (the "Platform").
                </p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 text-center">
                <h2 className="text-3xl font-bold text-red-900 mb-4">NO REFUND POLICY</h2>
                <p className="text-xl text-slate-700 leading-relaxed mb-0">
                  We do not have a refund or return policy for any products or services purchased on the Platform.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Policy Overview</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                LEARNERS EDGE operates on a <strong>NO REFUND, NO RETURN</strong> policy. All sales of courses, educational materials, and services are final. Once payment is made and course access is granted (subject to admin approval), no refunds or returns will be processed under any circumstances.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Understanding Our Policy</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                By purchasing or enrolling in any course or service on our Platform, you acknowledge and agree that:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>All payments are <strong>final and non-refundable</strong></li>
                <li>No returns will be accepted for any digital or physical products</li>
                <li>Course access, once granted, cannot be revoked for refund purposes</li>
                <li>Payment disputes will not result in refunds</li>
                <li>Technical issues on your end do not qualify for refunds</li>
                <li>Dissatisfaction with course content does not warrant a refund</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Before You Purchase</h2>
              <p className="text-slate-700 mb-4 leading-relaxed">
                We encourage you to:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Carefully review all course information, descriptions, and preview content before making a purchase</li>
                <li>Ensure you meet all technical requirements to access the course materials</li>
                <li>Read and understand our Terms of Use and Privacy Policy</li>
                <li>Contact our support team if you have any questions before purchasing</li>
                <li>Verify payment details and course selection before completing the transaction</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Payment Processing</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                All payments are processed securely through our payment gateway. Once a payment is successfully processed:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>The transaction is considered complete and binding</li>
                <li>Your enrollment request will be submitted for admin approval</li>
                <li>No cancellation or refund requests will be entertained</li>
                <li>You will receive a confirmation email with your purchase details</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Exceptions</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                There are <strong>NO EXCEPTIONS</strong> to this policy. Refunds will not be provided under any circumstances, including but not limited to:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Change of mind or personal circumstances</li>
                <li>Technical difficulties or internet connectivity issues</li>
                <li>Inability to complete the course</li>
                <li>Duplicate purchases</li>
                <li>Accidental purchases</li>
                <li>Payment errors or mistakes</li>
                <li>Course difficulty level or content expectations</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Course Access Issues</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                If you experience technical issues accessing your course after admin approval, please contact our support team. We will work to resolve access issues, but this does not constitute grounds for a refund. Our obligation is limited to providing access to the purchased course content.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Fraudulent Transactions</h2>
              <p className="text-slate-700 mb-6 leading-relaxed">
                In case of suspected fraudulent transactions or payment disputes initiated by your bank or payment provider, we reserve the right to:
              </p>
              <ul className="list-disc list-inside text-slate-700 mb-6 space-y-2">
                <li>Suspend or terminate your account access</li>
                <li>Report the matter to appropriate authorities</li>
                <li>Take legal action to recover any losses</li>
              </ul>
              <p className="text-slate-700 mb-6 leading-relaxed">
                No refunds will be processed even in cases where chargebacks or payment disputes are filed.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">Contact Information</h2>
              <p className="text-slate-700 mb-2 leading-relaxed">
                For any questions or concerns regarding this Refund & Return Policy, please contact us:
              </p>
              <ul className="list-none text-slate-700 mb-6 space-y-1">
                <li>Email: admin@learnersedge.in / learnersedge2.0@gmail.com</li>
                <li>Phone: +91 9219485048</li>
                <li>Address: Ghaziabad, UP India</li>
                <li>Website: learnersedge.in</li>
              </ul>

              <div className="bg-yellow-50 border-l-4 border-yellow-600 p-6 mt-8">
                <p className="text-sm text-slate-700 leading-relaxed mb-0">
                  <strong>Final Reminder:</strong> By proceeding with any purchase on our Platform, you explicitly acknowledge that you have read, understood, and agreed to this NO REFUND, NO RETURN policy. Please make informed decisions before completing any transaction.
                </p>
              </div>

              <div className="bg-slate-100 p-4 rounded-lg mt-8">
                <p className="text-sm text-slate-600 italic">
                  This Refund & Return Policy was last updated on January 2025.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Refund;
